import { SelectionOption, Selection as SelectionType } from '../../../../../../types/Survey/Element'
import { Selection as SelectionAnalysisType, Option } from '../../../../../../types/Survey/Analysis/Element'
import { Props } from './types'
import Core from './Core'
import Pie, { Item as PieItem } from '../../../../../UI/Chart/Pie/Pie'
import Bar, { Item as BarItem } from '../../../../../UI/Chart/Bar/Bar'
import { ChartType } from './ChartSelector'
import { useState } from 'react'
import { round } from 'lodash'

const Selection: React.FC<Props<SelectionType, SelectionAnalysisType>> = ({ element, analysisElement }) => {
  const [activeChart, setActiveChart] = useState(ChartType.BAR)

  const getBarChartItems = (): BarItem[] => {
    const items = element.options.map((o: SelectionOption) => {
      const analysisOption: Option = analysisElement.options.find((aO) => aO.uuid === o.uuid)
      return {
        key: o.uuid,
        value: round(analysisOption.percentage),
        label: `${o.value}`,
      }
    })

    const totalValues = items.reduce((acc, i) => acc + i.value, 0)
    return items.map((i) => ({ ...i, value: (i.value / totalValues) * 100 }))
  }
  const getPieChartItems = (): PieItem[] => {
    const items = element.options.map((o: SelectionOption) => {
      const analysisOption: Option = analysisElement.options.find((aO) => aO.uuid === o.uuid)
      return {
        value: round(analysisOption.percentage),
        label: `${o.value}`,
      }
    })

    const totalValues = items.reduce((acc, i) => acc + i.value, 0)
    return items.map((i) => ({ ...i, value: round((i.value / totalValues) * 100) }))
  }

  return (
    <div>
      <Core element={element} availableChartOptions={[ChartType.PIE, ChartType.BAR]} activeChart={activeChart} setActiveChart={setActiveChart} />
      <div className="mt-5 flex justify-center">
        {activeChart === ChartType.PIE && (
          <div className="w-full">
            <Pie items={getPieChartItems()} enableDownload />
          </div>
        )}
        {activeChart === ChartType.BAR && <Bar enableDownload items={getBarChartItems()} />}
      </div>
    </div>
  )
}

export default Selection
